@use '../../../styles/Colors.scss' as Colors;
@use '../../../styles/Constants.scss' as Constants;

.row-edit-mode {
	border: 1px solid Colors.$col-orangeBorder !important;
	background-color: Colors.$col-design-orange5 !important;

	& + & {
		border-top: none !important;
		margin-top: 0 !important;
	}
}


.delete-cell {
	& > [class^="icon-delete"] {
		color: Colors.$col-canceledRed;
		font-size: Constants.$val-fontSizeBig;
		cursor: pointer;

		&:hover {
			color: Colors.$color-red;
		}
	}
}

.edit-cell {
	& > [class^="icon-"] {
		color: Colors.$col-blue;
		font-size: Constants.$val-fontSizeBig;
		cursor: pointer;

		&:hover {
			color: Colors.$col-darkBlueBorder;
		}
	}
}

.newly-saved-row {
	animation: newly-added 2000ms normal;
}

.row-with-error {
	& > span {
		&:has(.edit-cell) {
			& > span > [class^="icon-"] {
				color: Colors.$col-design-blue3 !important;
				cursor: not-allowed;
			}
		}
	}
}

@keyframes newly-added {
	0% {
		background: Colors.$col-design-orange6;
	}

	100% {
		background: Colors.$col-design-grey13;
	}
}